import { createSelector } from '@ngrx/store';
import {
  sharedResourcesAdapter,
  SharedResourcesState,
} from '@core/shared-resources/store/shared-resources.reducer';
import { CollectionsState, getCollectionsState } from '../../../collections/collections.reducer';

export const getSharedResourcesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.sharedResources,
);
export const { selectEntities: getSharedResourcesEntities } =
  sharedResourcesAdapter.getSelectors(getSharedResourcesState);
export const getCurrentSharedResourceTeamMemberIds = createSelector(
  getSharedResourcesState,
  (state: SharedResourcesState) =>
    !!state && state.currentResource.teamMembers.map((teamMember) => teamMember.id),
);
export const getCurrentSharedResourceTeamMembers = createSelector(
  getSharedResourcesState,
  (state: SharedResourcesState) => !!state && state.currentResource.teamMembers,
);

export const getCurrentSharedResource = createSelector(
  getSharedResourcesState,
  (state: SharedResourcesState) => !!state && state.currentResource,
);
